import { useState, useCallback } from 'react';

const galleryImages = [
  // Resultados
  {
    src: "https://static.readdy.ai/image/86a2daa6c77fa935b9acdedfc02e0e91/0b49e62303e7642b6f57f753f4bbeb72.jpeg",
    alt: "Prueba de botella de separación agua-crudo en laboratorio – tres muestras con demulsificante RESINVENCA",
    caption: "Prueba de Botella – Separación Óptima",
    category: "Resultados",
    span: 2,
  },
  {
    src: "https://static.readdy.ai/image/86a2daa6c77fa935b9acdedfc02e0e91/cb6cf83152b2e9f5faae4dff399c104e.jpeg",
    alt: "Probetas graduadas mostrando separación clara de fases agua-crudo con demulsificante RESINVENCA",
    caption: "Separación de Fases en Probeta",
    category: "Resultados",
    span: 1,
  },
  {
    src: "https://static.readdy.ai/image/86a2daa6c77fa935b9acdedfc02e0e91/5828a834d8607f0e005af60a482065d9.jpeg",
    alt: "Muestra de crudo en botella de prueba tomada directamente en campo petrolero",
    caption: "Prueba de Botella – Campo Real",
    category: "Resultados",
    span: 1,
  },
  // Laboratorio
  {
    src: "https://storage.helloreaddy.io/project_files/9755469e-cfe9-4755-b8ae-44d6e19e4537/43457cc6-a84b-4ec8-9f7e-4f6e4b7b1c30_compressed_WhatsApp-Image-2026-07-28-at-12.24.10-PM.webp",
    alt: "Laboratorio de Poly Alphas Chemicals C.A. con múltiples botellas de prueba de demulsificante alineadas en mesa de trabajo",
    caption: "Laboratorio de Pruebas – Setup Completo",
    category: "Laboratorio",
    span: 2,
  },
  {
    src: "https://storage.helloreaddy.io/project_files/9755469e-cfe9-4755-b8ae-44d6e19e4537/b4061420-9d1e-4426-9992-4d94601e0fd8_compressed_WhatsApp-Image-2026-07-28-at-12.24.09-PM-2.webp",
    alt: "Pruebas de dosis de demulsificante con jeringas insertadas en botellas pequeñas para evaluación de separación",
    caption: "Evaluación de Dosis Óptima",
    category: "Laboratorio",
    span: 1,
  },
  {
    src: "https://storage.helloreaddy.io/project_files/9755469e-cfe9-4755-b8ae-44d6e19e4537/6e06cd38-da51-4465-8d4c-ba0f91e5be76_compressed_WhatsApp-Image-2026-07-28-at-12.24.09-PM.webp",
    alt: "Botellas numeradas con muestras de crudo en laboratorio de Poly Alphas Chemicals C.A. listas para análisis",
    caption: "Muestras de Crudo – Pruebas de Separación",
    category: "Laboratorio",
    span: 1,
  },
  {
    src: "https://storage.helloreaddy.io/project_files/9755469e-cfe9-4755-b8ae-44d6e19e4537/d22ca550-b932-4951-8780-361cd2d7fec3_compressed_WhatsApp-Image-2026-07-28-at-12.24.08-PM-1.webp",
    alt: "Secuencia de botellas con crudo numeradas mostrando etapas de prueba de demulsificación",
    caption: "Resultados Secuenciales de Separación",
    category: "Laboratorio",
    span: 1,
  },
  {
    src: "https://static.readdy.ai/image/86a2daa6c77fa935b9acdedfc02e0e91/42862eddf739d32b013cdf187dde0b32.jpeg",
    alt: "Técnico dosificando muestra con pipeta sobre balanza analítica digital en laboratorio de formulación de demulsificantes",
    caption: "Dosificación Precisa en Balanza Analítica",
    category: "Laboratorio",
    span: 1,
  },
  {
    src: "https://static.readdy.ai/image/86a2daa6c77fa935b9acdedfc02e0e91/82c727ebc95c127b734df257ae7b9094.jpeg",
    alt: "Botellas de vidrio numeradas del 5 al 8 con muestras de crudo oscuro dispuestas en bandeja metálica de laboratorio",
    caption: "Muestras Secuenciales para Análisis",
    category: "Laboratorio",
    span: 1,
  },
  {
    src: "https://static.readdy.ai/image/86a2daa6c77fa935b9acdedfc02e0e91/2540fc7569f5d42988e11c198c37ba8a.jpeg",
    alt: "Viales pequeños con jeringas de precisión y etiquetas amarillas preparados para evaluación de dosis de demulsificante",
    caption: "Evaluación de Dosis con Jeringas de Precisión",
    category: "Laboratorio",
    span: 1,
  },
  // Campo
  {
    src: "https://readdy.ai/api/search-image?query=Industrial%20oil%20separation%20tank%20at%20petroleum%20processing%20facility%20in%20Venezuela%2C%20large%20cylindrical%20separator%20with%20visible%20oil-water%20interface%2C%20warm%20sunset%20lighting%2C%20dramatic%20industrial%20atmosphere%2C%20orange%20and%20dark%20tones&width=800&height=600&seq=demuls-gallery-03&orientation=landscape",
    alt: "Tanque separador de crudo en instalación petrolera venezolana",
    caption: "Separador en Campo Petrolero",
    category: "Campo",
    span: 2,
  },
  {
    src: "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Orinoco%20oil%20belt%20heavy%20oil%20production%20facility%20in%20Venezuela%2C%20vast%20industrial%20complex%20with%20storage%20tanks%20and%20processing%20units%2C%20warm%20tropical%20atmosphere%2C%20cinematic%20drone%20photography%2C%20dramatic%20clouds&width=800&height=600&seq=demuls-gallery-07&orientation=landscape",
    alt: "Vista aérea de instalación de producción en la Faja Petrolífera del Orinoco",
    caption: "Instalación – Faja Petrolífera del Orinoco",
    category: "Campo",
    span: 1,
  },
  // Logística
  {
    src: "https://static.readdy.ai/image/86a2daa6c77fa935b9acdedfc02e0e91/ac97c662ce0a78a0b34e3dda83ab2d0d.jpeg",
    alt: "Contenedor de exportación con dos totems IBC de demulsificante listos para envío",
    caption: "Totems IBC en Contenedor de Exportación",
    category: "Logística",
    span: 1,
  },
  {
    src: "https://static.readdy.ai/image/86a2daa6c77fa935b9acdedfc02e0e91/edad2fece331a7fa1770d7c2620bbf4c.png",
    alt: "Bodega industrial con múltiples contenedores IBC de demulsificante apilados y listos para distribución",
    caption: "Almacenamiento de IBCs en Planta",
    category: "Logística",
    span: 2,
  },
  {
    src: "https://readdy.ai/api/search-image?query=Industrial%20blue%20chemical%20drums%20and%20IBC%20containers%20stored%20in%20organized%20warehouse%20for%20petroleum%20chemicals%2C%20clean%20industrial%20storage%20facility%2C%20professional%20logistics%20photography%2C%20warm%20ambient%20lighting&width=800&height=600&seq=demuls-gallery-08&orientation=landscape",
    alt: "Tambores e IBC de demulsificante almacenados en bodega industrial",
    caption: "Almacenamiento y Logística",
    category: "Logística",
    span: 1,
  },
  // Exportación
  {
    src: "https://static.readdy.ai/image/86a2daa6c77fa935b9acdedfc02e0e91/8af4a4cebc39b301a3468bfbc64db0f6.jpeg",
    alt: "Montacargas cargando totem IBC de demulsificante en camión contenedor en planta China",
    caption: "Carga de Exportación – Planta China",
    category: "Exportación",
    span: 2,
  },
  {
    src: "https://static.readdy.ai/image/86a2daa6c77fa935b9acdedfc02e0e91/5fd4fc07a5bfa7cb928268f69dd8ae7c.jpeg",
    alt: "Montacargas cargando múltiples totems IBC en contenedor para exportación desde China",
    caption: "Carga de Múltiples IBCs para Exportación",
    category: "Exportación",
    span: 1,
  },
];

const categories = ["Todos", "Campo", "Laboratorio", "Resultados", "Logística", "Exportación"];

export default function GallerySection() {
  const [activeFilter, setActiveFilter] = useState("Todos");
  const [lightboxIndex, setLightboxIndex] = useState<number | null>(null);

  const filteredImages = activeFilter === "Todos"
    ? galleryImages
    : galleryImages.filter((img) => img.category === activeFilter);

  const openLightbox = useCallback((index: number) => setLightboxIndex(index), []);
  const closeLightbox = useCallback(() => setLightboxIndex(null), []);
  const prevImage = useCallback(() => {
    if (lightboxIndex !== null) {
      setLightboxIndex(lightboxIndex === 0 ? filteredImages.length - 1 : lightboxIndex - 1);
    }
  }, [lightboxIndex, filteredImages.length]);
  const nextImage = useCallback(() => {
    if (lightboxIndex !== null) {
      setLightboxIndex(lightboxIndex === filteredImages.length - 1 ? 0 : lightboxIndex + 1);
    }
  }, [lightboxIndex, filteredImages.length]);

  return (
    <section id="galeria" className="bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8 lg:px-16">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="text-center mb-10 md:mb-14">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-5">
              <i className="ri-gallery-line text-sm w-4 h-4 flex items-center justify-center"></i>
              Galería de Resultados
            </div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
              El Demulsificante <span className="text-primary-500">en Acción</span>
            </h2>
            <p className="text-foreground-500 text-sm max-w-xl mx-auto">
              Imágenes reales de pruebas de laboratorio con Poly Alphas Chemicals C.A., aplicación en campo, logística de exportación desde China y resultados documentados en Venezuela.
            </p>
          </div>

          {/* Filters */}
          <div className="flex flex-wrap items-center justify-center gap-2 md:gap-3 mb-10">
            {categories.map((cat) => (
              <button
                key={cat}
                onClick={() => {
                  setActiveFilter(cat);
                  setLightboxIndex(null);
                }}
                className={`px-4 py-2 rounded-full text-xs md:text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                  activeFilter === cat
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-50 text-foreground-600 border border-background-200/60 hover:border-primary-300/60"
                }`}
              >
                {cat}
              </button>
            ))}
          </div>

          {/* Gallery Grid - Masonry with dense auto-flow */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5" style={{ gridAutoFlow: 'dense' }}>
            {filteredImages.map((image, index) => (
              <div
                key={image.src}
                onClick={() => openLightbox(index)}
                className={`group relative rounded-lg overflow-hidden cursor-pointer border border-background-200/60 hover:border-primary-300/60 transition-all duration-300 select-none ${
                  image.span === 2 ? "sm:col-span-2" : ""
                }`}
              >
                <div className={`overflow-hidden ${image.span === 2 ? "aspect-[16/9]" : "aspect-[4/3]"}`}>
                  <img
                    src={image.src}
                    alt={image.alt}
                    className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500 select-none"
                    draggable="false"
                  />
                </div>
                {/* Anti-download overlay */}
                <div
                  className="absolute inset-0 z-10"
                  onContextMenu={(e) => e.preventDefault()}
                  aria-hidden="true"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-4 md:p-5 z-20">
                  <span className="text-primary-300 text-xs font-medium uppercase tracking-wide mb-1">{image.category}</span>
                  <p className="text-white font-heading text-sm md:text-base font-semibold">{image.caption}</p>
                </div>
                <div className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center rounded-full bg-background-50/90 text-foreground-700 opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-20">
                  <i className="ri-zoom-in-line text-sm"></i>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Lightbox */}
      {lightboxIndex !== null && (
        <div
          className="fixed inset-0 z-[100] bg-foreground-950/95 backdrop-blur-sm flex items-center justify-center p-3 md:p-0"
          onClick={closeLightbox}
          onContextMenu={(e) => e.preventDefault()}
        >
          <button
            onClick={(e) => { e.stopPropagation(); closeLightbox(); }}
            className="absolute top-5 right-5 w-10 h-10 flex items-center justify-center rounded-full bg-background-50/20 text-background-50 hover:bg-background-50/30 transition-all duration-200 cursor-pointer"
          >
            <i className="ri-close-line text-xl"></i>
          </button>

          <button
            onClick={(e) => { e.stopPropagation(); prevImage(); }}
            className="absolute left-4 md:left-8 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-background-50/20 text-background-50 hover:bg-background-50/30 transition-all duration-200 cursor-pointer"
          >
            <i className="ri-arrow-left-line text-lg md:text-xl"></i>
          </button>

          <button
            onClick={(e) => { e.stopPropagation(); nextImage(); }}
            className="absolute right-4 md:right-8 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-background-50/20 text-background-50 hover:bg-background-50/30 transition-all duration-200 cursor-pointer"
          >
            <i className="ri-arrow-right-line text-lg md:text-xl"></i>
          </button>

          <div className="max-w-5xl w-full mx-4 md:mx-8" onClick={(e) => e.stopPropagation()}>
            <div className="rounded-lg overflow-hidden relative">
              <img
                src={filteredImages[lightboxIndex].src}
                alt={filteredImages[lightboxIndex].alt}
                className="w-full max-h-[60vh] md:max-h-[70vh] object-contain select-none"
                draggable="false"
              />
              {/* Anti-download overlay */}
              <div
                className="absolute inset-0 z-10"
                onContextMenu={(e) => e.preventDefault()}
                aria-hidden="true"
              />
            </div>
            <div className="text-center mt-4">
              <span className="text-primary-400 text-xs font-medium uppercase tracking-wide">{filteredImages[lightboxIndex].category}</span>
              <p className="text-white font-heading text-base font-semibold mt-1">{filteredImages[lightboxIndex].caption}</p>
              <p className="text-foreground-400 text-xs mt-1">{filteredImages[lightboxIndex].alt}</p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}